import axios from "axios";
import { EMULATION_ALL, buildRequestUrl, execWithApiToken, EmulatedProductData } from '../../GlobalStateContainer/actions'


const EMULATION_MODE_LOCATIONSMNGT = false


/*
 * LocationsMngt Actions
 * 
 */

export function fetchLocationsMngtList() {
    let cmd = 'FETCH_LOCATIONSMNGT_LIST'

    if (EMULATION_ALL || EMULATION_MODE_LOCATIONSMNGT)
        //TODO - needs to be fixed
        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: EmulatedProductData
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.get(buildRequestUrl('LocationMgmtAdmin'), { headers: { 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function addLocationOption(location, option) {
    this.props.dispatch(
        {
            type: 'NEW_LOCATION_OPTION',
            payload: {
                data: {
                    location: location,
                    option: option
                }
            }
        }
    )
}

export function selAllLocationOptions(location) {
    this.props.dispatch(
        {
            type: 'ALL_LOCATION_OPTIONS',
            payload: {
                data: {
                    location: location
                }
            }
        }
    )
}

export function selSelLocationOptions(location, opts) {
    this.props.dispatch(
        {
            type: 'SEL_LOCATION_OPTIONS',
            payload: {
                data: {
                    location: location,
                    options: opts
                }
            }
        }
    )
}

export function unSelLocationOption(location, opt) {
    this.props.dispatch(
        {
            type: 'UNSEL_LOCATION_OPTION',
            payload: {
                data: {
                    location: location,
                    option: opt
                }
            }
        }
    )
}

export function unSelAllLocationOptions(location) {
    this.props.dispatch(
        {
            type: 'NO_LOCATION_OPTIONS',
            payload: {
                data: {
                    location: location
                }
            }
        }
    )
}

export function updateLocations(locations) {
    let cmd = 'UPDATE_LOCATIONS'

    if (EMULATION_ALL || EMULATION_MODE_LOCATIONSMNGT)

        this.props.dispatch(
            {
                type: cmd + '_FULFILLED',
                payload: {
                    data: locations
                }
            }
        )

    else {
        execWithApiToken(this.props.dispatch, cmd, (dispatch, token) => {
            dispatch(
                {
                    type: cmd
                }
            )

            axios.put(buildRequestUrl('LocationMgmtAdmin'), JSON.stringify(locations), { headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token } })
                .then((resp) => {
                    dispatch(
                        {
                            type: cmd + '_FULFILLED',
                            payload: resp
                        }
                    )
                })
                .catch((err) => {
                    dispatch(
                        {
                            type: cmd + '_REJECTED',
                            payload: err
                        }
                    )
                })
        })
    }
}

export function fetchLocationsMngtError(dispatch) {
    dispatch(
        {
            type: 'FETCH_LOCATIONSMNGT_ERROR',
        }
    )
}

export function errorLocationsMngt(dispatch) {

    dispatch(
        {
            type: 'LOCATIONSMNGT_ERROR',
        }
    )
}
